var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "hero hero-header has-sticky-module-header",
      class: `has-hero-text-${_vm.$theme.name} ${`theme-${_vm.$theme.name}`}`,
    },
    [
      _c("div", { staticClass: "hero-body paddingless hanger" }, [
        _c("nav", { staticClass: "navbar" }, [
          _c("div", { staticClass: "navbar-brand" }, [
            _c("div", { staticClass: "navbar-item is-hidden-desktop" }, [
              _c(
                "div",
                { staticClass: "field is-grouped" },
                [
                  _vm._t("mobile-left", function () {
                    return [
                      _vm.showToggle
                        ? _c("p", { staticClass: "control" }, [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "button tooltip is-tooltip-topleft is-primary is-light",
                                class: _vm.buttonCSS,
                                attrs: {
                                  disabled: !_vm.buttonsEnabled,
                                  title: "Toggle Side Menu",
                                  "data-tooltip": "Toggle Side Menu",
                                },
                                on: { click: _vm.toggleSide },
                              },
                              [_vm._m(0)]
                            ),
                          ])
                        : _vm._e(),
                      !_vm.licenceExpired &&
                      _vm.access.isDelete &&
                      !_vm.serviceError &&
                      _vm.showCalendar
                        ? _c("p", { staticClass: "control" }, [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "button tooltip is-tooltip-topleft",
                                class: _vm.buttonCSS,
                                attrs: {
                                  id: "calendar",
                                  title: "Calendar",
                                  "data-tooltip": "Calendar",
                                },
                                on: { click: _vm.calendar },
                              },
                              [_vm._m(1)]
                            ),
                          ])
                        : _vm._e(),
                      !_vm.licenceExpired &&
                      _vm.access.isAdd &&
                      !_vm.serviceError &&
                      _vm.showNew
                        ? _c("p", { staticClass: "control" }, [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "button tooltip is-tooltip-topleft",
                                class: _vm.buttonCSS,
                                attrs: {
                                  id: "addnew",
                                  title: "Add New",
                                  "data-tooltip": "Add New",
                                },
                                on: { click: _vm.addNew },
                              },
                              [_vm._m(2)]
                            ),
                          ])
                        : _vm._e(),
                      _vm.access.isPrint && !_vm.serviceError && _vm.showPrint
                        ? _c("p", { staticClass: "control" }, [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "button tooltip is-tooltip-topleft",
                                class: _vm.buttonCSS,
                                attrs: {
                                  id: "print",
                                  title: "Print",
                                  "data-tooltip": "Print",
                                },
                                on: { click: _vm.print },
                              },
                              [_vm._m(3)]
                            ),
                          ])
                        : _vm._e(),
                      !_vm.licenceExpired &&
                      _vm.access.isDelete &&
                      !_vm.serviceError &&
                      _vm.showDelete
                        ? _c("p", { staticClass: "control" }, [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "button tooltip is-tooltip-topleft",
                                class: _vm.buttonCSS,
                                attrs: {
                                  id: "delete",
                                  title: "Delete",
                                  "data-tooltip": "Delete",
                                },
                                on: { click: _vm.trash },
                              },
                              [_vm._m(4)]
                            ),
                          ])
                        : _vm._e(),
                      !_vm.licenceExpired &&
                      _vm.access.isEdit &&
                      !_vm.serviceError &&
                      _vm.showSave &&
                      !(_vm.showAutoSave && _vm.entity && !_vm.entity.isNew)
                        ? _c("p", { staticClass: "control" }, [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "button tooltip is-tooltip-topleft",
                                class: _vm.buttonCSS,
                                attrs: {
                                  id: "save",
                                  title: "Save",
                                  "data-tooltip": "Save",
                                },
                                on: { click: _vm.save },
                              },
                              [_vm._m(5)]
                            ),
                          ])
                        : _vm._e(),
                      _vm.showCancel
                        ? _c("p", { staticClass: "control" }, [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "button tooltip is-tooltip-topleft",
                                class: _vm.buttonCSS,
                                attrs: {
                                  id: "cancel",
                                  title: "Go Back",
                                  "data-tooltip": "Go Back",
                                },
                                on: { click: _vm.cancel },
                              },
                              [_vm._m(6)]
                            ),
                          ])
                        : _vm._e(),
                      _vm.showLock
                        ? _c("p", { staticClass: "control" }, [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "button tooltip is-tooltip-topleft",
                                class: _vm.buttonCSS,
                                attrs: {
                                  id: "lock",
                                  disabled: _vm.isSaving,
                                  title: "Lock Manage",
                                  "data-tooltip": "Lock Manage",
                                },
                                on: {
                                  click: function ($event) {
                                    !_vm.isSaving && _vm.toggleReadOnly()
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "icon" }, [
                                  _c("span", { staticClass: "msr" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.entity.readOnly
                                          ? "lock"
                                          : "lock_open"
                                      )
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              ),
            ]),
            _vm._m(7),
          ]),
          _c(
            "div",
            {
              staticClass: "navbar-start is-hidden-touch",
              attrs: { id: "detail-nav-menu" },
            },
            [
              _vm.showToggle
                ? _c("div", { staticClass: "navbar-item" }, [
                    _c("h1", { staticClass: "title" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button is-primary is-outlined",
                          class: _vm.buttonCSS,
                          attrs: { disabled: !_vm.buttonsEnabled },
                          on: { click: _vm.toggleSide },
                        },
                        [_vm._m(8)]
                      ),
                    ]),
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "navbar-item" },
                [_vm._t("desktop-left")],
                2
              ),
            ]
          ),
          _vm.$slots["center"]
            ? _c(
                "div",
                { staticClass: "navbar-item has-text-centered" },
                [_vm._t("center")],
                2
              )
            : _vm._e(),
          _c("div", { staticClass: "navbar-end is-hidden-touch" }, [
            _c("div", { staticClass: "navbar-item" }, [
              _c(
                "div",
                { staticClass: "field is-grouped" },
                [
                  _vm._t("desktop-right", function () {
                    return [
                      !_vm.licenceExpired &&
                      _vm.access.isAdd &&
                      !_vm.serviceError &&
                      _vm.showCalendar
                        ? _c("p", { staticClass: "control" }, [
                            _c(
                              "a",
                              {
                                staticClass: "button is-primary",
                                class: _vm.buttonCSS,
                                attrs: { id: "calendar" },
                                on: { click: _vm.calendar },
                              },
                              [_vm._m(9), _c("span", [_vm._v("Calendar")])]
                            ),
                          ])
                        : _vm._e(),
                      !_vm.licenceExpired &&
                      _vm.access.isAdd &&
                      !_vm.serviceError &&
                      _vm.showNew
                        ? _c("p", { staticClass: "control" }, [
                            _c(
                              "a",
                              {
                                staticClass: "button is-success",
                                class: _vm.buttonCSS,
                                attrs: { id: "addnew" },
                                on: { click: _vm.addNew },
                              },
                              [_vm._m(10), _c("span", [_vm._v("New")])]
                            ),
                          ])
                        : _vm._e(),
                      _vm.access.isPrint &&
                      !_vm.serviceError &&
                      _vm.showPrint &&
                      false
                        ? _c("p", { staticClass: "control" }, [
                            _c(
                              "a",
                              {
                                staticClass: "button is-primary",
                                class: _vm.buttonCSS,
                                attrs: { id: "preview" },
                                on: { click: _vm.print },
                              },
                              [_vm._m(11), _c("span", [_vm._v("Preview")])]
                            ),
                          ])
                        : _vm._e(),
                      !_vm.licenceExpired &&
                      _vm.access.isDelete &&
                      !_vm.serviceError &&
                      _vm.showDelete &&
                      false
                        ? _c("p", { staticClass: "control" }, [
                            _c(
                              "a",
                              {
                                staticClass: "button is-danger",
                                class: _vm.buttonCSS,
                                attrs: { id: "delete" },
                                on: { click: _vm.trash },
                              },
                              [_vm._m(12), _c("span", [_vm._v("Delete")])]
                            ),
                          ])
                        : _vm._e(),
                      !_vm.licenceExpired &&
                      _vm.access.isEdit &&
                      !_vm.serviceError &&
                      _vm.showConvert
                        ? _c("p", { staticClass: "control" }, [
                            _c(
                              "a",
                              {
                                staticClass: "button is-primary",
                                class: _vm.buttonCSS,
                                attrs: { id: "convert" },
                                on: { click: _vm.convert },
                              },
                              [_vm._m(13), _c("span", [_vm._v("Convert")])]
                            ),
                          ])
                        : _vm._e(),
                      !_vm.licenceExpired &&
                      _vm.access.isEdit &&
                      !_vm.serviceError &&
                      _vm.showSave &&
                      _vm.autoSaveEnabled &&
                      _vm.entity &&
                      !_vm.entity.isNew
                        ? _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    content: _vm.autoSaveStatus,
                                    enabled: true,
                                  },
                                  expression:
                                    "{ content: autoSaveStatus, enabled: true }",
                                },
                              ],
                              staticClass:
                                "control is-flex is-flex-direction-row is-align-items-center mr-2",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "material-symbols-rounded mr-2",
                                  class: {
                                    loading:
                                      _vm.isSaving && !_vm.hasAutoSaveFailed,
                                    "has-text-grey":
                                      (_vm.isSaving || _vm.unsavedChanges) &&
                                      !_vm.hasAutoSaveFailed,
                                    "has-text-danger": _vm.hasAutoSaveFailed,
                                    "has-text-grey-light":
                                      !_vm.isSaving &&
                                      !_vm.hasAutoSaveFailed &&
                                      !_vm.unsavedChanges,
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.isSaving
                                          ? "sync"
                                          : _vm.hasAutoSaveFailed
                                          ? "cloud_off"
                                          : "cloud_done"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      !_vm.licenceExpired &&
                      _vm.access.isEdit &&
                      !_vm.serviceError &&
                      _vm.showSave &&
                      _vm.autoSaveLocked
                        ? _c("p", { staticClass: "control" }, [
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      content: _vm.hasAutoSaveFailed
                                        ? "Autosave failed - Click to save manually"
                                        : "",
                                      enabled: _vm.hasAutoSaveFailed,
                                    },
                                    expression:
                                      "{ content: hasAutoSaveFailed ? 'Autosave failed - Click to save manually' : '', enabled: hasAutoSaveFailed }",
                                  },
                                ],
                                staticClass: "button is-success",
                                class: [_vm.buttonCSS],
                                attrs: { id: "save" },
                                on: { click: _vm.save },
                              },
                              [
                                _c("span", { staticClass: "icon" }, [
                                  _c("span", { staticClass: "msr msr-18px" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.hasAutoSaveFailed
                                          ? "cloud_off"
                                          : "save"
                                      )
                                    ),
                                  ]),
                                ]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.hasAutoSaveFailed
                                        ? "Save Manually"
                                        : _vm.entity && _vm.entity.isNew
                                        ? "Create"
                                        : "Save"
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm.showCancel
                        ? _c("p", { staticClass: "control" }, [
                            _c(
                              "a",
                              {
                                staticClass: "button is-primary",
                                class: _vm.buttonCSS,
                                attrs: { id: "cancel" },
                                on: { click: _vm.cancel },
                              },
                              [_vm._m(14), _c("span", [_vm._v("Back")])]
                            ),
                          ])
                        : _vm._e(),
                    ]
                  }),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.hasMoreActions,
                          expression: "hasMoreActions",
                        },
                      ],
                      staticClass: "button px-2",
                      attrs: { name: "headerMoreButtons" },
                      on: { mouseenter: _vm.handleMoreButtonHover },
                    },
                    [_vm._m(15)]
                  ),
                ],
                2
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._t("additional-content", function () {
        return [
          _vm.hasMoreActions
            ? _c(
                "tippy",
                {
                  ref: "tippyHeaderButtons",
                  attrs: {
                    to: "headerMoreButtons",
                    trigger: "click",
                    arrow: "",
                    theme: `${_vm.$theme.name}`,
                    interactive: true,
                    "max-width": 500,
                  },
                },
                [
                  _c("div", { staticClass: "menu more-menu" }, [
                    _c(
                      "ul",
                      { staticClass: "menu-list" },
                      [
                        !_vm.licenceExpired &&
                        !_vm.serviceError &&
                        _vm.showCreditorStatement
                          ? _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass: "is-flex is-align-items-center",
                                  attrs: { id: "viewCreditorStatement" },
                                  on: { click: _vm.viewCreditorStatement },
                                },
                                [
                                  _c("span", { staticClass: "icon pr-3" }, [
                                    _c(
                                      "span",
                                      { staticClass: "msr msr-20px" },
                                      [_vm._v("request_page")]
                                    ),
                                  ]),
                                  _c("span", [
                                    _vm._v("View Creditor Statement"),
                                  ]),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        !_vm.licenceExpired &&
                        !_vm.serviceError &&
                        _vm.showDebtorStatement
                          ? _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass: "is-flex is-align-items-center",
                                  attrs: { id: "viewDebtorStatement" },
                                  on: { click: _vm.viewDebtorStatement },
                                },
                                [
                                  _c("span", { staticClass: "icon pr-3" }, [
                                    _c(
                                      "span",
                                      { staticClass: "msr msr-20px" },
                                      [_vm._v("request_page")]
                                    ),
                                  ]),
                                  _c("span", [_vm._v("View Debtor Statement")]),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        !_vm.licenceExpired &&
                        !_vm.serviceError &&
                        _vm.showAdvancePaymentEntry
                          ? _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass: "is-flex is-align-items-center",
                                  attrs: { id: "viewAdvancePaymentEntry" },
                                  on: { click: _vm.viewAdvancePaymentEntry },
                                },
                                [
                                  _c("span", { staticClass: "icon pr-3" }, [
                                    _c(
                                      "span",
                                      { staticClass: "msr msr-20px" },
                                      [_vm._v("request_page")]
                                    ),
                                  ]),
                                  _c("span", [_vm._v("Advance Payment Entry")]),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        !_vm.licenceExpired &&
                        !_vm.serviceError &&
                        _vm.showAdvanceReceiptEntry
                          ? _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass: "is-flex is-align-items-center",
                                  attrs: { id: "viewAdvanceReceiptEntry" },
                                  on: { click: _vm.viewAdvanceReceiptEntry },
                                },
                                [
                                  _c("span", { staticClass: "icon pr-3" }, [
                                    _c(
                                      "span",
                                      { staticClass: "msr msr-20px" },
                                      [_vm._v("request_page")]
                                    ),
                                  ]),
                                  _c("span", [_vm._v("Advance Receipt Entry")]),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        !_vm.licenceExpired &&
                        !_vm.serviceError &&
                        _vm.showFactorInvoice
                          ? _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass: "is-flex is-align-items-center",
                                  attrs: { id: "factorInvoice" },
                                  on: { click: _vm.factorInvoice },
                                },
                                [
                                  _c("span", { staticClass: "icon pr-3" }, [
                                    _c(
                                      "span",
                                      { staticClass: "msr msr-20px" },
                                      [_vm._v("receipt_long")]
                                    ),
                                  ]),
                                  _c("span", [_vm._v("Factor Invoices")]),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        !_vm.licenceExpired &&
                        !_vm.serviceError &&
                        _vm.showFactorSelectedInvoice
                          ? _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass: "is-flex is-align-items-center",
                                  attrs: { id: "factorSelectedInvoice" },
                                  on: { click: _vm.factorSelectedInvoice },
                                },
                                [
                                  _c("span", { staticClass: "icon pr-3" }, [
                                    _c(
                                      "span",
                                      { staticClass: "msr msr-20px" },
                                      [_vm._v("receipt_long")]
                                    ),
                                  ]),
                                  _c("span", [
                                    _vm._v("Factor Selected Invoices"),
                                  ]),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        !_vm.licenceExpired &&
                        !_vm.serviceError &&
                        _vm.showBankUnDepositedFunds
                          ? _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass: "is-flex is-align-items-center",
                                  attrs: { id: "viewBankUnDepositedFunds" },
                                  on: { click: _vm.viewBankUnDepositedFunds },
                                },
                                [
                                  _c("span", { staticClass: "icon pr-3" }, [
                                    _c(
                                      "span",
                                      { staticClass: "msr msr-20px" },
                                      [_vm._v("account_balance")]
                                    ),
                                  ]),
                                  _c("span", [
                                    _vm._v("Bank Un-Deposited Funds"),
                                  ]),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        !_vm.licenceExpired &&
                        _vm.access.isEdit &&
                        !_vm.serviceError &&
                        _vm.showSave &&
                        _vm.autoSaveEnabled &&
                        _vm.entity &&
                        !_vm.entity.isNew &&
                        !_vm.hasAutoSaveFailed
                          ? _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass: "is-flex is-align-items-center",
                                  attrs: { id: "manualSave" },
                                  on: { click: _vm.manualSave },
                                },
                                [
                                  _c("span", { staticClass: "icon pr-3" }, [
                                    _c(
                                      "span",
                                      { staticClass: "msr msr-20px" },
                                      [_vm._v("save")]
                                    ),
                                  ]),
                                  _c("span", [_vm._v("Save")]),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm.access.isPrint && !_vm.serviceError && _vm.showPrint
                          ? _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass: "is-flex is-align-items-center",
                                  attrs: { id: "preview" },
                                  on: { click: _vm.print },
                                },
                                [
                                  _c("span", { staticClass: "icon pr-3" }, [
                                    _c(
                                      "span",
                                      { staticClass: "msr msr-20px" },
                                      [_vm._v("print")]
                                    ),
                                  ]),
                                  _c("span", [_vm._v("Preview")]),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        !_vm.licenceExpired && !_vm.serviceError && _vm.showLock
                          ? _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass: "is-flex is-align-items-center",
                                  class: {
                                    "has-text-grey-light": _vm.isSaving,
                                  },
                                  attrs: { id: "lock" },
                                  on: {
                                    click: function ($event) {
                                      !_vm.isSaving && _vm.toggleReadOnly()
                                    },
                                  },
                                },
                                [
                                  _c("span", { staticClass: "icon pr-3" }, [
                                    _c(
                                      "span",
                                      { staticClass: "msr msr-20px" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.entity.readOnly
                                              ? "lock"
                                              : "lock_open"
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.entity.readOnly ? "Unlock" : "Lock"
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        !_vm.serviceError && _vm.showPricePartsMsg
                          ? _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass: "is-flex is-align-items-center",
                                  attrs: { id: "priceparts" },
                                  on: { click: _vm.viewPricePartsMsg },
                                },
                                [
                                  _c("span", { staticClass: "icon pr-3" }, [
                                    _c(
                                      "span",
                                      { staticClass: "msr msr-20px" },
                                      [_vm._v("chat")]
                                    ),
                                  ]),
                                  _c("span", [
                                    _vm._v("View Price Parts Messages"),
                                  ]),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        !_vm.licenceExpired &&
                        _vm.access.isEdit &&
                        !_vm.serviceError &&
                        _vm.showAdditionalQuoteButtons &&
                        _vm.showAdditionalQuote
                          ? _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "is-flex is-align-items-center pl-1",
                                  attrs: { id: "new_additional_quote" },
                                  on: { click: _vm.newAdditionalQuote },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "msr msr-24px mr-1",
                                      staticStyle: { "font-size": "20px" },
                                    },
                                    [_vm._v(" add ")]
                                  ),
                                  _c("span", [_vm._v("New Additional Quote")]),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        !_vm.licenceExpired &&
                        _vm.access.isEdit &&
                        !_vm.serviceError &&
                        _vm.showAdditionalQuoteButtons
                          ? _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "is-flex is-align-items-center pl-1",
                                  attrs: { id: "copy_quote" },
                                  on: { click: _vm.copyQuote },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "msr msr-24px mr-1",
                                      staticStyle: { "font-size": "20px" },
                                    },
                                    [_vm._v(" content_copy ")]
                                  ),
                                  _c("span", [_vm._v("Copy Quote")]),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        !_vm.licenceExpired &&
                        _vm.access.isEdit &&
                        !_vm.serviceError &&
                        _vm.showAdditionalQuoteButtons
                          ? _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "is-flex is-align-items-center pl-1",
                                  attrs: { id: "export_quote" },
                                  on: { click: _vm.exportQuote },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "msr msr-24px mr-1",
                                      staticStyle: { "font-size": "20px" },
                                    },
                                    [_vm._v(" file_export ")]
                                  ),
                                  _c("span", [_vm._v("Export Quote")]),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        !_vm.licenceExpired &&
                        !_vm.serviceError &&
                        _vm.showQuoteTemplate
                          ? _c("li", [
                              !_vm.quoteTemplateDisabled
                                ? _c("div", [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "is-flex is-align-items-center",
                                        attrs: { id: "quoteTemplate" },
                                        on: {
                                          click: _vm.saveTemplateFromQuote,
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "icon pr-3" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "msr msr-20px" },
                                              [_vm._v("add")]
                                            ),
                                          ]
                                        ),
                                        _c("span", [
                                          _vm._v("Save as Template"),
                                        ]),
                                      ]
                                    ),
                                  ])
                                : _c("div", [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "is-flex is-align-items-center button is-white is-fullwidth pl-0 is-justify-content-flex-start",
                                        attrs: {
                                          id: "quoteTemplate",
                                          disabled: _vm.quoteTemplateDisabled,
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "icon ml-0" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "msr msr-20px" },
                                              [_vm._v("print")]
                                            ),
                                          ]
                                        ),
                                        _c("span", [
                                          _vm._v("Save as Template"),
                                        ]),
                                      ]
                                    ),
                                  ]),
                            ])
                          : _vm._e(),
                        !_vm.licenceExpired &&
                        _vm.access.isDelete &&
                        !_vm.serviceError &&
                        _vm.showDelete &&
                        _vm.showPrint
                          ? _c("div", { staticClass: "is-divider" })
                          : _vm._e(),
                        !_vm.licenceExpired &&
                        _vm.access.isDelete &&
                        !_vm.serviceError &&
                        _vm.showDelete
                          ? _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "has-text-danger is-flex is-align-items-center",
                                  attrs: { id: "delete" },
                                  on: { click: _vm.trash },
                                },
                                [
                                  _c("span", { staticClass: "icon pr-3" }, [
                                    _c(
                                      "span",
                                      { staticClass: "msr msr-20px" },
                                      [_vm._v("delete")]
                                    ),
                                  ]),
                                  _c("span", [_vm._v("Delete")]),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._t("more-menu-items"),
                      ],
                      2
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "msr" }, [_vm._v("menu")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-calendar" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "msr" }, [_vm._v("add")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "msr" }, [_vm._v("print")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "msr" }, [_vm._v("delete")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "msr" }, [_vm._v("save")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "msr" }, [_vm._v("arrow_back")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "navbar-burger burger",
        attrs: { "data-target": "action-button-menu" },
      },
      [_c("span"), _c("span"), _c("span")]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "msr msr-24px" }, [_vm._v("menu")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-calendar mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "msr msr-18px" }, [_vm._v("add")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "msr msr-18px" }, [_vm._v("print")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "msr msr-18px" }, [_vm._v("delete")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-swap-horizontal mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "msr msr-18px" }, [_vm._v("arrow_back")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("span", { staticClass: "msr msr-36px" }, [_vm._v("more_vert")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }